<!--

 -->

<template>
  <teleport to="#app">
    <simple-dialog
      v-if="show"
      :with-close="false"
      class="gsl-hrm-confirmation-dialog gsl-hrm-dialog-popup"
      @update:show="onSuccess"
    >
      <div class="gsl-hrm-modal-header">
        <oxd-text type="card-title">
          {{ $t('recruitment.application_received') }}
        </oxd-text>
      </div>
      <div class="gsl-hrm-text-center-align">
        <oxd-text type="card-body">
          {{
            $t('recruitment.your_application_has_been_submitted_successfully')
          }}
        </oxd-text>
      </div>
      <div class="gsl-hrm-modal-footer">
        <oxd-button
          :label="$t('general.ok')"
          display-type="text"
          class="gsl-hrm-button-margin"
          @click="onSuccess"
        />
      </div>
    </simple-dialog>
  </teleport>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';

export default {
  name: 'SuccessDialog',
  components: {
    'simple-dialog': OxdDialog,
  },
  data() {
    return {
      show: false,
      resolve: null,
    };
  },
  methods: {
    showSuccessDialog() {
      return new Promise((resolve) => {
        this.resolve = resolve;
        this.show = true;
      });
    },
    onSuccess() {
      this.show = false;
      this.resolve && this.resolve('ok');
    },
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-modal-header {
  margin-bottom: 1.2rem;
  display: flex;
  justify-content: center;
}

.gsl-hrm-modal-footer {
  margin-top: 1.2rem;
  display: flex;
  justify-content: center;
}

.gsl-hrm-button-margin {
  margin: 0.25rem;
}

.gsl-hrm-text-center-align {
  text-align: center;
}
</style>
